export default __webpack_public_path__ + "static/media/yellow-circle.3c443c3a.png";